import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
	extend: {
		theme: {
			// ↓ `text` is the key of the namespace `--text-*`
			//      ↓ `tiny` is the variable name in the namespace
			// text: ["tiny"],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return customTwMerge(clsx(inputs));
}
